var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9982C0 8.95348 8.95348 0 19.9982 0V0C31.0428 0 39.9963 8.95348 39.9963 19.9982V19.9982C39.9963 31.0428 31.0428 39.9963 19.9982 39.9963V39.9963C8.95348 39.9963 0 31.0428 0 19.9982V19.9982Z",
    fill: "#2F91F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4026 25.7708L18.8826 14.4748H21.1546L25.5866 25.7708H22.9306L19.5386 16.3948H20.4506L17.0106 25.7708H14.4026ZM16.9466 23.7228V21.6748H23.1066V23.7228H16.9466Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProf);
export default __webpack_public_path__ + "static/media/prof.f24e7962cb37d7fcf1090e8c76c8921f.svg";
export { ForwardRef as ReactComponent };